import constant from '../constant'
import axios from 'axios'

export default {
  data: {
    menus: [],
    resources:[],
    menuLoading: false,
    tags:[]
  },
  actions: {
    getMenuList: async ({commit, state}, params) => {
      state.menuLoading = true
      let r = await axios.get('/admin/my-menus/resources')
      state.menuLoading = false
      commit(constant.GET_MENU_LIST, r)
    },
  },
  mutations: {
    [constant.GET_MENU_LIST](state, data) {
     state.menus = data.data.menus
      state.resources=data.data.resources
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/module/menuStore.js